"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonCardHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
const CommonCardHeader = ({
  headerTextId = '',
  headerPrice = ''
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "common-card-header",
    "data-testid": "common-card-header",
    className: "d-flex flex-row justify-content-between common-card-header pb-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ms2",
    "data-testid": "common-card-header-text"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: headerTextId
  })), headerPrice && /*#__PURE__*/_react.default.createElement("div", {
    className: "ms2 d-flex align-items-center",
    "data-testid": "common-card-header-price"
  }, headerPrice));
};
exports.CommonCardHeader = CommonCardHeader;
CommonCardHeader.propTypes = {
  headerTextId: _propTypes.default.string,
  headerPrice: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};